export function formatCurrency(amount: number) {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

export function capitalizeString(target: string): string {
  return target.charAt(0).toUpperCase() + target.slice(1);
}
